import { render } from "./addRemove.vue?vue&type=template&id=a71f8ff0&scoped=true"
import script from "./addRemove.vue?vue&type=script&lang=js"
export * from "./addRemove.vue?vue&type=script&lang=js"

import "./addRemove.vue?vue&type=style&index=0&id=a71f8ff0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a71f8ff0"]])

export default __exports__